import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

// Shared toggle for case-listing surfaces (customer case management + admin
// console). Permanently-deleted (tombstoned) cases are hidden by default and
// revealed on demand. Deleted cases remain in the data for billing/cost
// reconciliation; this toggle is purely presentational.
export default function ShowDeletedToggle({ checked, onChange, label = 'Show deleted cases' }) {
  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
        />
      }
      label={label}
      sx={{ ml: 0, color: 'var(--text-secondary)' }}
    />
  );
}
